import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface Props {
  title?: string
  isFiltered: boolean
}

const NoDataInDataGridTable = ({ title = 'No data', isFiltered }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'start',
        marginTop: '50px',
        height: '100%',
        gap: '8px',
      }}
    >
      <Typography>{isFiltered ? 'Nothing found' : title}</Typography>
    </Box>
  )
}

export default NoDataInDataGridTable
